import apiRequest from '../../lib/http'

export const downloadEnrolledReport = async () => {
  const response = await apiRequest.post('/exports/enrolled-report', {}, {
    responseType: 'blob'
  })

  const contentDisposition = response.headers['content-disposition']
  let filename = `enrolled_report.csv`
  if (contentDisposition) {
    const match = contentDisposition.match(/filename="?([^";\n]+)"?/)
    if (match) filename = match[1]
  }

  const url = window.URL.createObjectURL(new Blob([response.data]))
  const link = document.createElement('a')
  link.href = url
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  link.remove()
  window.URL.revokeObjectURL(url)

  return { filename }
}
